const HomeScreen = ({ onCreate, onJoin }) => (
  <div className="card">
    <div className="logo-tag">✊ 🖐️ ✌️</div>
    <h1>ROCK <span className="accent">PAPER</span> SCISSORS</h1>
    <p className="subtitle">Real-time PvP — Challenge a Friend Live</p>

    <button className="btn btn-primary" onClick={onCreate}>
      🎮 Create Room
    </button>
    <button className="btn btn-secondary" onClick={onJoin}>
      🔗 Join Room
    </button>
  </div>
);

export default HomeScreen;